import WorkReport from '../sections/work-report';
import PermissionGuard from '../components/auth/PermissionGuard';
import { permissions } from '../config/permissions';

const WorkReportPage = () => {
  return (
    <PermissionGuard permissions={[permissions.VIEW_REPORTS]}>
      <WorkReport />
    </PermissionGuard>
  );
};

export default WorkReportPage;
